import { render, staticRenderFns } from "./paper-steps.vue?vue&type=template&id=70d4bfc4&scoped=true"
import script from "./paper-steps.vue?vue&type=script&lang=ts"
export * from "./paper-steps.vue?vue&type=script&lang=ts"
import style0 from "./paper-steps.vue?vue&type=style&index=0&id=70d4bfc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d4bfc4",
  null
  
)

export default component.exports